import { Injectable, Inject, InjectionToken, EventEmitter } from '@angular/core';
import { noop } from 'lodash-es';

export const ESTENSA_MODULE_BUS_SERVICE = new InjectionToken('estensa.module.bus.service');

// TODO: Considerare se fare lo stesso della controparte AngularJS, definendo le varie interfacce.
export interface IBusData {
    messageType: string;
    data?: any;
}

export interface IBusServiceNg1 {
    notify(data: IBusData): void;
    register(fn: (data: IBusData) => void);
}

@Injectable()
export class NullBusService implements IBusServiceNg1 {
    notify = noop;
    register = noop;
}

@Injectable({
    providedIn: 'root',
})
export class EstensaBusWrapperService {
    // events

    busDataFired: EventEmitter<any> = new EventEmitter<any>();

    // constructor

    constructor(@Inject(ESTENSA_MODULE_BUS_SERVICE) private estensaBusService: IBusServiceNg1) {
        this.estensaBusService.register(busData => {
            this.busDataFired.emit(busData);
        });
    }

    // public functions

    notify(busData: IBusData) {
        this.estensaBusService.notify(busData);
    }
}
